// Short-lived memory only. Never persist admin records in browser storage.
const MAX_AGE = 2 * 60 * 1000;
let actor = null;
const sections = new Map();

export function clearAdminSectionCache() {
  actor = null;
  sections.clear();
}

function selectActor(id) {
  if (actor !== id) {
    clearAdminSectionCache();
    actor = id;
  }
}

export function readAdminSectionCache(id, key) {
  selectActor(id);
  if (!id) return null;
  const entry = sections.get(key);
  if (!entry || Date.now() - entry.savedAt >= MAX_AGE) {
    sections.delete(key);
    return null;
  }
  return entry.data;
}

export function writeAdminSectionCache(id, key, data) {
  selectActor(id);
  if (id) sections.set(key, { data, savedAt: Date.now() });
}
